import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable, exhaustMap } from 'rxjs';
import { fromPromise } from 'rxjs/internal/observable/innerFrom';
import { LocalStorage } from 'src/app/shared/providers/local-storage/local-storage';
import { NetworkProvider } from 'src/app/shared/providers/network/network';
import { servicesUrl } from '../../config';
import { CrtHttpErrorHandlerService } from '../../providers/http-error-handler.service';

/**
 * Service des alarmes CRT
 */
@Injectable({
  providedIn: 'root',
})
export class CrtDocumentsService extends LocalStorage {
  /**
   * Clef de stockage par site
   * @type {string}
   */
  private readonly DOCUMENT_STORAGE_KEY = 'crt-${id}-document';

  /**
   * Constructeur
   * @param {Storage} storage
   * @param {NetworkProvider} network
   * @param {HttpClient} http
   * @param crtHttpErrorHandler
   */
  constructor(
    protected override storage: Storage,
    protected override network: NetworkProvider,
    private http: HttpClient,
    private crtHttpErrorHandler: CrtHttpErrorHandlerService
  ) {
    super();
    this.serverRequestPeriod = 10;
  }

  public getDocuments(
    id: number,
    type: TypeImage,
    nomFichier: string,
    transmetteur: string,
    forceRefresh = false
  ): Observable<ArrayBuffer> {
    const url = servicesUrl.getDocuments({ type: type, nomFichier: nomFichier });
    const key = this.formatStorageKey(this.DOCUMENT_STORAGE_KEY, { id });

    let params = {};
    if (transmetteur) {
      params = {
        transmetteur: transmetteur,
      };
    }

    return this.shouldUseWebservice(key, forceRefresh).pipe(
      exhaustMap((shouldUseWebservice) => {
        if (shouldUseWebservice) {
          return new Observable<string>((observer) => {
            this.http.get(url, { params: params, responseType: 'blob' }).subscribe({
              next: (response) => {
                const reader = new FileReader();
                response = response.slice(0, response.size, 'image/png');
                reader.readAsDataURL(response);
                reader.onloadend = () => {
                  this.storage.set(key, <string>reader.result);
                  this.setLastRequestDateToNow(key);
                  observer.next(<string>reader.result);
                  observer.complete();
                };
              },
              error: () => {
                observer.next('Erreur recuperation photos');
                observer.complete();
              },
            });
            return { unsubscribe() {} };
          });
        } else {
          return fromPromise(this.storage.get(key));
        }
      })
    );
  }
}

export enum TypeImage {
  IMAGE_LOI = 'IMAGE_LOI',
}
